import { render } from "./ShiftRecommendations.vue?vue&type=template&id=228be7bb"
import script from "./ShiftRecommendations.vue?vue&type=script&lang=js"
export * from "./ShiftRecommendations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__